var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar-title',{class:_vm.$store.state.account.current ? 'pl-1' : 'pl-10'},[_vm._v(_vm._s(_vm.$t("site-name")))])
}
var staticRenderFns = []

export { render, staticRenderFns }